import React from "react";
import { cn } from "../../lib/utils";

const CallScoreBadge = ({ score, className, ...props }) => {
  const numericScore = parseFloat(score);
  
  const getVariantStyles = (score) => {
    if (score >= 80) {
      return "bg-[#DCFAE6] text-[#079455] border-green-200 font-semibold dark:bg-green-900/20 dark:text-green-300 dark:border-green-800";
    } else if (score >= 60) {
      return "bg-blue-50 text-blue-700 border-blue-200 font-semibold dark:bg-blue-900/20 dark:text-blue-300 dark:border-blue-800";
    } else if (score >= 40) {
      return  "bg-[#FEF0C7] text-[#DC6803] font-semibold border-yellow-200 dark:bg-yellow-900/20 dark:text-yellow-300 dark:border-yellow-800";
    } else {
      return "bg-[#FEE4E2] text-[#D92D20] border-red-200  font-semibold dark:bg-red-900/20 dark:text-red-300 dark:border-red-800";
    }
  };

  return (
    <span
      className={cn(
        "inline-flex items-center justify-center text-xs font-semibold",
        "w-10 h-10 rounded-full border transition-colors",
        getVariantStyles(numericScore),
        className
      )}
      {...props}
    >
      {score}
    </span>
  );
};

export { CallScoreBadge }; 